
<template>
  <div>
    <b-container style="container_custom" fluid>
      <b-row>
        <b-col cols='8'>
        <b-row>
          <b-col cols='8'>
          <b-card header-bg-variant="primary" header-text-variant="white" header="মূখ্য সূচনাসমূহ" class="cardStyle">
                  <marquee direction = "up" scrollamount="3" behavior="scroll" style='height:60vh;'
                    onmouseover="this.stop();" onmouseout="this.start();">
                      <ul id="news">
                        <li>
                          <span class='notificationHeader' >Notice</span>
                          <br><span style='font-size:0.9rem;'><a href="https://www.apdcl.org/website/docs/documents/notice/prepaid_to_postpaid_conversion.pdf" target="_blank"> Conversion of LT postpaid connections (having smart meters installed) into prepaid connections. </a> ||  <a href="https://www.apdcl.org/website/docs/documents/notice/annexure_postpaid_to_prepaid.pdf" target="_blank"><strong> Annexure A - D </strong></a></span>
                        </li>
                        <li v-for="item in getNews" :key="item.name">
                          <span class='notificationHeader' >{{ item.type }}</span>
                          <br><span style='font-size:0.9rem;' v-html="item.name"></span>
                        </li>
                    </ul>
                  </marquee>
          </b-card>
        </b-col>


        <b-col cols="4" >
          <b-card header-bg-variant="primary" header-text-variant="white" header="প্ৰকল্প আৰু আঁচনি" class="cardStyle">
                <ul class="cardList">
                  <li><a href="AS_PmSurya" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> প্ৰধানমন্ত্ৰী সূৰ্য ঘৰ : বিনামূলীয়া বিজুলী আঁচনি</a></li>
                  <li><a href="RdssProject" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> আৰ ডি এছ এছ প্ৰকল্পসমূহ <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>--></a></li>
                  <li><a href="Aiib" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> এ আই আই বি প্ৰকল্পসমূহ <!--<img src='https://www.apdcl.org/website/assets/new.gif'/>--></a></li>
                  <li><router-link :to="{ path: '/AS_Project', query: { showdiv: 'saubhagya' }}" class="card-link fontStyle"><b-icon icon="caret-right" /> সৌভাগ্য আঁচনি</router-link></li>
                  <li><b-link :to="{ path: '/AS_Project', query: { showdiv: 'ipds' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> আই.পি.দি.এছ.</b-link></li>
                  <li><b-link :to="{ path: '/AS_Project', query: { showdiv: 'ddugjy' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" /> দি.দি.ইউ.জি.জে.ৱাই.</b-link></li>
                  <li><b-link :to="{ path: '/AS_Project', query: { showdiv: 'uday' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1" /> উদয় আঁচনি</b-link></li>
                  <li><b-link :to="{ path: '/AS_Project', query: { showdiv: 'akashdeep' }}" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> আকাশদীপ আঁচনি</b-link></li>
                  <!-- <b-link href="https://www.apdcl.org/website/docs/project/solar.pdf" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"  /> Roof-Top Solar Project</b-link></li> -->
                  <li><b-link href="http://www.rodalee.com/" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> ৰুফটপ্‌ সৌৰ প্ৰকল্প</b-link></li>
                  <li><b-link href="http://www.rodalee.com/" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> পি এম কুছুম-উপাদান A</b-link></li>
                  <!-- <li>
                    <b-link href="VldScheme"  class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" />Voluntary Load Declaration Scheme
                    </b-link>
                    
                    </li> -->
                    <li>
                      <b-link href="OneTimeSettlement"  class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" />এককালীন নিষ্পত্তি আঁচনি
                    </b-link>
                    </li>
                </ul>
            </b-card>
        </b-col>
      </b-row>
      <!-- <b-row>
        <b-col cols='12'>
        <div   class="cardStyle2" >
               <b-img src='../assets/bihu_ad.jpg' fluid-grow alt="Fluid-grow image"></b-img>
        </div>
      </b-col>
    </b-row> -->
    </b-col>

          <b-col cols="4">
            <b-card header-bg-variant="primary" header-text-variant="white" header="মূখ্য লিংকসমূহ" class="cardStyle">
              <b-row>
                <!--<b-col>
                  <b-icon icon="link45deg" style="color: #4dd0e1; height: 5vw; width:5vw; float:left;margin-top:50px;"></b-icon>
                </b-col>-->
                <b-col cols='12'>
                  <ul class="a cardList overfloww">
                    <li>
                    <b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/CorporateSalaryPackage">
                        <b-icon icon="caret-right" font-scale="1" /> কৰ্পৰেট দৰমহাৰ পেকেজ
                      </router-link>
                    </b-link>
                    <img src='https://www.apdcl.org/website/assets/new.gif' />
                  </li>
                    <li>
                      <b-link href="https://www.apdcl.org/website/docs/documents/Holiday list APDCL.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" />ছুটীৰ তালিকা ২০২৬
                      </b-link>
                      <!-- <img src='https://www.apdcl.org/website/assets/new.gif' /> -->
                    </li>
                    
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/SolarLandApplication">
                        <b-icon icon="caret-right" font-scale="1" />ভূমি বেংকৰ প্ৰয়োজনীয়তাৰ বাবে আবেদন
                      </router-link>
                      </b-link>
                      <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/> -->
                    </li>
                    
                    <li>
                        <b-link href="VldScheme"  class="card-link fontStyle">
                          <b-icon icon="caret-right" font-scale="1" /> স্বেচ্ছামূলক বিদ্যুত ঘোষণা আঁচনি
                        </b-link>
                        <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/> -->
                     </li>
                    <li>
                      <b-link href="https://www.apdcl.org/cgrf/login" target="_blank" class="card-link fontStyle"><b-icon icon="caret-right" font-scale="1"/> এপিডিচিএল গ্ৰাহক অভিযোগ নিৰাময় পৰ্টেল</b-link>
                     <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/>-->
                    </li>
                    <li>
                      <b-icon icon="caret-right" font-scale="1" /> 
                        <b-link v-b-modal.modal-header class="card-link fontStyle">
                          অতিৰিক্ত ৰাশি ঘূৰাই দিয়া
                      </b-link>
                     <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/>-->
                     </li>
                     <!--<li>
                      <b-icon icon="caret-right" font-scale="1" /> 
                      <b-link href="https://www.apdcl.org/website/docs/documents/GrivenceRedresselPolicy.pdf" target="_blank" class="card-link fontStyle">
                        এনপিএছৰ অধীনত এপিডিচিএলৰ অভিযোগ নিষ্পত্তি নীতি
                      </b-link>
                    <img src='https://www.apdcl.org/website/assets/new.gif'/>
                     </li>-->
                    <li><b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/AS_DuplicateReceipt">
                        <b-icon icon="caret-right" font-scale="1" /> ৰচিদৰ প্ৰতিলিপি
                      </router-link>
                      </b-link>
                    </li>

                    <li>
                        <b-link href="#" class="card-link fontStyle">
                          <router-link toggle-class="r-link" to="/AS_ReprintVoucher">
                          <b-icon icon="caret-right" font-scale="1" /> প্ৰি-পেইদ্‌ ভাউচাৰ
                        </router-link>
                        </b-link>
                      </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                      <router-link toggle-class="r-link" to="/AS_OnlineChangeProcess">
                      <b-icon icon="caret-right" font-scale="1" /> ল'ড/কেটেগ'ৰী সাল-সলনি প্ৰক্ৰিয়া
                      </router-link>
                    </b-link>
                   </li>
                   <li>
                     <b-link href="#" class="card-link fontStyle">
                     <router-link toggle-class="r-link" to="/AS_CheckApplStatus">
                     <b-icon icon="caret-right" font-scale="1" /> আবেদনৰ স্থিতিৰ বিষয়ে জানক
                     </router-link>
                   </b-link>
                  </li>
                   <!-- <li>
                     <b-link href="#" class="card-link fontStyle">
                       <router-link toggle-class="r-link" to="/KnowConsNo">
                       <b-icon icon="caret-right" font-scale="1" /> Know 12 digit Consumer Number
                       </router-link>
                     </b-link>
                  </li> -->
                    <!-- <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/KnowConsNoPrepaid">
                        <b-icon icon="caret-right" font-scale="1" /> Know Prepaid Consumer Number
                        </router-link>
                      </b-link>

                     </li> -->

                
                    <!-- <li><b-link href="#" class="card-link fontStyle">Online Change Process</b-link></li> -->
                    <!-- <li><b-link href="#" class="card-link fontStyle">Present Power Scenario</b-link></li> -->
                   <!-- <li>
                      <b-link href="https://www.bharatbillpay.com/Billpay.php" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> ভাৰত বিল-পে ৰ জৰিয়তে পৰিশোধ কৰক
                      </b-link>
                    </li>-->
                    <li>
                      <b-link href="http://www.bijuleebandhu.com/" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> বিজুলী-বন্ধুৰ জৰিয়তে অভিযোগ পঞ্জীয়ন কৰক
                      </b-link>

                    </li>
                    <li>
                      <b-link href="https://www.apdclrms.com/cms/login" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> ঠিকা ব্যৱস্থাপনা প্ৰণালী
                      </b-link>
                    </li>

                    <li>
                      <b-link href="https://www.apdclrms.com/easypay/login" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> এপিডিচিএল ইজি-পে </b-link>
                     </li>
                     <li>
                    <b-link href="EstimateServiceCost"  class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" /> নতুন বিদ্যুৎ সংযোগ খৰচ কেলকুলেটৰ
                    </b-link>
                    <!-- <img src='https://www.apdcl.org/website/assets/new.gif'/> -->
                    </li>
                    <li>
                    <b-link href="EodbReport"  class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" /> ই. অ. ডি. বি. ৰ প্ৰতিবেদন
                    </b-link>
                 
                    </li>
                    <li>
                      <b-link href="https://www.apdcl.org/website/docs/acts_and_rules/mobile_update_form.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> মোবাইল নম্বৰ নবীকৰণ প্ৰ-পত্ৰ </b-link>
                      
                     </li>
                     <li>
                      <b-link href="https://www.apdcl.org/website/docs/RTI/RTI_FAA_and_SPIO.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> পৰিচালন সঞ্চালক, এপিডিচিএল কাৰ্যালয়ৰ বাবে প্ৰথম আপীল কৰ্তৃপক্ষ আৰু এছ. পি. আই. অ'</b-link>
                        
                     </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/AS_AssociatedSites"><b-icon icon="caret-right" font-scale="1" /> সংলগ্ন ৱেবচাইটসমূহ</router-link>
                      </b-link>
                    </li>
                    <li>
                      <b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/AS_Safety"><b-icon icon="caret-right" font-scale="1" /> বিদ্যুৎ সুৰক্ষা</router-link>
                      </b-link>
                    </li>
                    <li><b-link href="#" class="card-link fontStyle">
                        <router-link toggle-class="r-link" to="/CompositeBilling">
                          <b-icon icon="caret-right" font-scale="1" /> সংযুক্ত বিল
                        </router-link>
                      </b-link>
                    </li>
                    <!-- <li>
                    <b-link href="AmicableForm" class="card-link fontStyle">
                      <b-icon icon="caret-right" font-scale="1" /> Amicable Settlement Scheme
                    </b-link>
                    </li> -->
                    
                    
                   <!-- <li>
                      <b-link href="https://www.apdcl.org/website/docs/acts_and_rules/Internal_Committee_APDCL.pdf" target="_blank" class="card-link fontStyle">
                        <b-icon icon="caret-right" font-scale="1" /> এপিডিচিএলৰ আভ্যন্তৰীণ সমিতিৰ তথ্য </b-link>
                     </li>-->
                     
                     
                    
                  </ul>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<style scopped="true">
  .cardStyle{
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.5);
  height:95vh;
 }
 
.cardStyle:hover {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  }
.overfloww {
    height:75vh;
  overflow-y: scroll;
}
  .cardStyle:hover {
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
  }
  ul {
    text-align: left;
    margin: 0;
    padding: 0;
  }
  li{
    padding-top:5px;
  }
  /* .card{
    max-height: 300px;
  } 
  .container_custom{

  }*/
  .fontStyle{
    font-weight: 500;
    font-size: 0.9rem;
  }
  .card-header{
      font-weight: bold;
  }
  .notificationHeader{
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.9rem;
    color:#424242 ;
  }
  ul {
    list-style-type: none;
  }
  .bg-primary {
    background-color: #0288d1   !important;
}
ul.cardList li
{
  border-bottom:1px solid #bdbdbd  ;
}
</style>
<script>
import HeaderFixed from '@/components/HeaderFixed.vue'
import { mapGetters, mapActions } from 'vuex'

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://www.apdcl.org/website";

export default {

  components: {
      'HeaderFixed' : HeaderFixed
    },
  data() {
      return {
       getNewsFields: [
           { key: 'type', label: '',thStyle: {width: '40vw'} },
          { key: 'name', label: '',thStyle: {width: '30vw'} },

         ]
      }

  },
  computed:
  {
    ...mapGetters([
      'getNews'
    ])
  },
  methods: {
    ...mapActions([
      'retrieveNews'

    ]),

    showDoc(id){
      var link = this.getDocument.filter(function(obj) { return obj.name == id; });
      console.log(link);
      window.open(this.$urlCommon +"/"+ link[0].path);
    }
  },
  beforeMount() {
      if(this.getNews.length == 0){
        this.retrieveNews();

      }
  },
  mounted()
  {
    // this.getNews.forEach(element => {
    // var node = document.createElement("LI");
    // node.innerHTML = ""
    // document.getElementById("news").appendChild(node);

  }

}
</script>
